import { IDecisionPreview } from 'ApiPackage/SearchModule/interfaces/IDecisionPreview';

import styles from '../styles.module.scss';
import { KnmSubtitle } from '../KnmSubtitle';

interface IDecisionProsecutor {
  passportData?: IDecisionPreview;
}

export const DecisionProsecutor = ({ passportData }: IDecisionProsecutor) => (
  <div className={styles.ColumnContent}>
    <KnmSubtitle title="Орган прокуратуры">
      {passportData?.prosecutorOrganization && (
        <div className={styles.Row}>
          <div className={styles.ColText}>Наименование прокуратуры</div>
          <div className={styles.ColValue}>{passportData?.prosecutorOrganization.name}</div>
        </div>
      )}
    </KnmSubtitle>
  </div>
);
